import "./css/Loading.css";

/* El velo de "esperá un momento" que tapa la pantalla mientras se resuelve la
 * sesión o una consulta.
 *
 * Era el camión azul heredado de CantApp girando sobre sí mismo. Se fue con el
 * resto de ese logo, y en su lugar va un aro y NO la marca nueva, por dos
 * razones. Un logo de 180px girando compite con lo que está atrás en vez de
 * acompañarlo; y una marca metida en un spinner envejece mal — el día que
 * cambie otra vez hay que acordarse de este archivo. Un aro no es de nadie.
 */
const Loading = () => (
  <div className="loading-page" role="status" aria-live="polite">
    <span className="loading-aro" />
    <span className="loading-texto">Cargando…</span>
  </div>
);

export default Loading;
